<template>
  <div v-loading.sync="loading">
    <div>
      <el-form class="table-form" ref="form" :model="queryModel" label-width="80px" size="small" inline
               @submit.native.prevent>
        <el-form-item label="用户名" prop="name" class="label-inline"
                      :rules="[{required: true, message: '查询用户名不能为空'}, {min: 2, message: '查询用户名不能少于2个字'}]">
          <el-input v-model="queryModel.name" placeholder="用户名模糊查询" class="inline-input"
                    @keyup.enter.native="refreshTable"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list" size="small" show-header border>
        <el-table-column label="序号" type="index" width="60px" align="center"></el-table-column>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="电话" prop="mobile"></el-table-column>
        <el-table-column label="角色" prop="role"></el-table-column>
        <el-table-column label="是否启用" prop="enabledLabel">
          <template slot-scope="{row}">
            <span>{{ row.enabledLabel }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否管理员" prop="isAdminLabel"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <div class="text-nowrap text-center">
              <el-button size="mini" @click="viewInfo(row)" icon="el-icon-search">查看</el-button>
              <el-button size="mini" @click="edit(row)">编辑</el-button>
              <el-button size="mini" @click="resetPwd(row)">重置密码</el-button>
              <el-popconfirm :title="'您确定要删除 ' + row.name + ' 用户数据吗？'" @confirm="remove(row)" style="margin-left: 10px">
                <el-button slot="reference" size="mini" type="danger">移除</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :total="page.totalElements" :current-page="page.number" @current-change="refreshTable"></el-pagination>
    </div>
    <el-dialog :visible.sync="viewInfoDialog">
      <user-detail :info="userInfo"></user-detail>
    </el-dialog>
  </div>
</template>

<script>
import Page from "@/models/Page";
import UserService from "@/services/user/UserService";
import User from "@/models/User";
import UserInfo from "@/models/UserInfo";
import UserDetail from "@/components/user/UserDetail";

export default {
  name: "UserList",
  components: {UserDetail},
  props: {},
  data() {
    return {
      queryModel: new User(),
      list: [],
      page: new Page(),
      loading: false,
      userInfo: new UserInfo(),
      viewInfoDialog: false
    }
  },
  mounted() {
    this.refreshTable()
  },
  methods: {
    viewInfo(u) {
      UserService.findUserInfo(u.id).then(resp => {
        if (resp.status === 200) {
          this.userInfo = new UserInfo(resp.data)
          this.viewInfoDialog = true
        }
      })
    },
    refreshTable(n) {
      this.loading = true
      UserService.fetchUserPage(new User(this.queryModel), {size: this.page.size, page: n - 1}).then(resp => {
        if (resp.status === 200 && resp.data) {
          this.page = Page.MapPageByResp(resp.data)
          this.list = resp.data.content.map(u => new User(u))
        }
      }).finally(() => this.loading = false)
    },
    edit(model) {
      this.$emit('edit', new User(model))
    },
    resetPwd(model) {
      this.loading = true
      let user = new User(model);
      let defaultPassword = "000000";
      this.$confirm("您确定要重置" + user.name + "的密码吗？", "密码重置确认").then(() => {
        UserService.modifyPwd(user.id, defaultPassword).then(resp => {
          if (resp.status === 200) {
            this.$message.info("密码已重置为:" + defaultPassword)
            this.refreshTable()
          }
        }).finally(() => this.loading = false)
      })
    },
    remove(model) {
      this.loading = true
      UserService.deleteUser(new User(model).id).then(resp => {
        if (resp.status === 200) {
          this.refreshTable()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>
